import { currentUser } from "./utils.js";
import { get } from "svelte/store";

const configsStaging = "https://beta-sb-app-configs-vlwut6qbsq-ew.a.run.app";
const configsLive = "https://sb-app-configs-jtdpxp3bfa-ew.a.run.app";

export const url = () => {
  return [true, "true"].includes(process["env"].PROD_ENV) ? configsLive : configsStaging;
};

const getUrl = (type) => {
  return url() + `/configs/${type}/customer/${get(currentUser).fullClientId}?token=${get(currentUser).accessToken}`;
};
const fetchUserConfig = async (type) => {
  const res = await fetch(getUrl(type));

  if (!res.ok) throw res;

  return await res.json();
};

const saveUserConfig = async (type, config) => {
  const res = await fetch(getUrl(type), {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(config),
  });
  return await res.json();
};

export const fetchUserBackendConfig = async () => {
  return await fetchUserConfig("backend");
};

export const fetchUserFrontendConfig = async () => {
  return await fetchUserConfig("frontend");
};

export const fetchUserAppConfig = async () => {
  return await fetchUserConfig("app-configs");
};

export const saveUserBackendConfig = async (config) => {
  return await saveUserConfig("backend", config);
};
export const saveUserFrontendConfig = async (config) => {
  return await saveUserConfig("frontend", config);
};
export const saveUserAppConfig = async (config) => {
  return await saveUserConfig("app-configs", config);
};
